<template>
  <!-- 工单列表 -->
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        type="primary"
        @click="workOrderAdd()"
        style=""
        icon="el-icon-circle-plus"
        >添加</el-button
      >

      <el-button
        type="primary"
        @click="initPrint('qiTaSheBeiTable')"
        icon="el-icon-printer"
        >打印</el-button
      >
    </div>

    <div class="rzy-top-bar">
      <div style="padding-left: 10px;">
        <el-date-picker
          @change="daterangeSelectChange()"
          v-model="daterangeSelectResult"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </div>

    <el-table
      :data="responseData"
      :header-cell-style="setHeaderCellStyle"
      :row-class-name="rowClass"
      :cell-style="setCellStyle"
      border
      stripe
      id="qiTaSheBeiTable"
    >
      <!--行-->
      <el-table-column sortable prop="local_id" align="center" label="行" width="50">
      </el-table-column>

      <el-table-column sortable prop="createTime" align="center" label="登记时间">
      </el-table-column>

      <el-table-column sortable prop="deviceKind" align="center" label="设备类型">
      </el-table-column>

      <el-table-column sortable prop="deviceNo" align="center" label="设备编号">
        <template slot-scope="scope">
          <el-link type="primary">
            {{ scope.row.deviceNo }}
          </el-link>
        </template>
      </el-table-column>

      <el-table-column sortable prop="deviceName" align="center" label="设备名称">
      </el-table-column>

      <el-table-column sortable prop="purchaseDate" align="center" label="采购时间">
      </el-table-column>

      <el-table-column sortable prop="depart" align="center" label="部门"> </el-table-column>

      <el-table-column sortable prop="provider" align="center" label="供应商">
      </el-table-column>

      <el-table-column sortable prop="unit" align="center" label="单位"> </el-table-column>

      <el-table-column sortable prop="deviceCount" align="center" label="数量">
      </el-table-column>

      <el-table-column sortable prop="creator" align="center" label="登记员">
      </el-table-column>

      <el-table-column sortable prop="remark" align="center" label="备注"> </el-table-column>

      <el-table-column sortable align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleClick1(scope.row.id)"
            type="text"
            size="small"
            >修改</el-button
          >
          <el-button
            @click="handleClick2(scope.row.id)"
            type="text"
            size="small"
            >删除</el-button
          >
          <el-button @click="handleClick3(scope.row)" type="text" size="small"
            >打印</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="text-align: center"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pageInfo.size"
      :current-page="pageInfo.page"
      :page-count="totalPages"
    >
    </el-pagination>
  </div>
</template>

<script>
import QRCode from "qrcode";
// import QRCode from "qrcode-generator";
import { workOrderDetails, dQueryInput } from "@/components/projectComponents";
// import printJS from "print-js";
export default {
  components: { dQueryInput },

  name: "workOrderList",
  data() {
    return {
      responseData: [],
      remarksButton: [],
      pageInfo: {
        page: 1,
        size: 15,
        //下面是 隐藏的 查询参数--sta
        /// status 0=审核不通过(待修改), 1=未审核(待审核), 2=已审核, , 3=结案。
        startTime: null, //开始时间
        endTime: null, //结束时间
        // fabricNumber: null, //胚布编号
        // fabricName: null, //胚布名称
        //下面是 隐藏的 查询参数--end
      },
      totalPages: 0,

      //日期范围选择控件 -- sta
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      daterangeSelectResult: "", //日期范围 选择的结果
      //日期范围选择控件 -- end
    };
  },
  computer: {},
  methods: {
    async generateQRCode(text, margin) {
      return new Promise((resolve, reject) => {
        QRCode.toDataURL(text, { margin: margin }, (error, url) => {
          if (error) {
            reject(error);
          } else {
            resolve(url);
          }
        });
      });
    },
    async handleClick3(rowData) {
      const qrCodeURL = await this.generateQRCode(rowData.deviceNo, 1);
      console.log(qrCodeURL);
      // 创建新窗口
      const printWindow = window.open("_blank");
      printWindow.document.open();
      printWindow.document.write(
        "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'><title>打印</title></head><body>"
      );

      // 添加样式
      printWindow.document.write("<style>");
      printWindow.document.write(
        ".content { font-size: 16px; width: 310px; height: 160px; display: flex; border: 1px solid #000; padding: 5px; margin: auto; }"
      );
      printWindow.document.write(".left { width: 50%; height: 100%; }");
      printWindow.document.write(".right { width: 50%; height: 100%; }");
      printWindow.document.write("img { width: 100%; height: 100%; }");
      printWindow.document.write("</style>");
      printWindow.document.write('<div class="content">');

      printWindow.document.write('<div class="left">');
      printWindow.document.write("<p>" + rowData.depart + "</p>");
      printWindow.document.write("<p>" + rowData.deviceName + "</p>");
      printWindow.document.write("<p>" + rowData.deviceNo + "</p>");
      printWindow.document.write("<p>" + rowData.createTime + "</p>");
      printWindow.document.write("</div>");
      printWindow.document.write('<div class="right">');
      printWindow.document.write(`<img src="${qrCodeURL}" />`);

      // 添加二维码图像
      // const qr = new QRCode(10, "H");
      // qr.addData(rowData.deviceNo,'Byte'); // 设置二维码内容
      // qr.make();
      // const qrDataUrl = qr.createDataURL(6, 0);
      // console.log(qrDataUrl);
      // printWindow.document.write('<div class="right">');
      // printWindow.document.write(
      //   '<img src="' + qrDataUrl + '" alt="QR Code" />'
      // );
      printWindow.document.write("</div>");

      printWindow.document.write("</div>");
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      setTimeout(function() {
        // 执行打印操作
        printWindow.print();
        printWindow.close();
        printWindow.focus();
      }, 1000);
      // printWindow.print();
      // printWindow.close();
      // printWindow.focus();
    },
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      let that = this;
      let columns = [0, 1, 2, 3, 4, 8, 11]; //想要改变列的索引
      if (columns.indexOf(columnIndex) > -1) {
        //有出现的话就返回center
        return "text-align:center;";
      } else {
        return "text-align:left;padding-left:15px;"; //没有的话就返回left
      }
    },
    setHeaderCellStyle({ row, column, rowIndex, columnIndex }) {
      let that = this;
      let columns = [0, 1, 2, 3, 4, 8, 11]; //想要改变列的索引
      if (columns.indexOf(columnIndex) > -1) {
        //有出现的话就返回center
        return "text-align:center;padding-left:10px; ";
      } else {
        return "text-align:left;padding-left:15px;"; //没有的话就返回left
      }
    },

    rowClass({ row, index }) {
      return `work-order-status${row.status}`;
    },

    // 跳转至新建生产单列表
    workOrderAdd() {
      this.$router.push({
        path: `otherDeviceAdd`,
        query: {
          type: 0, //0=新建, 1=编辑, 2=复制.
          // workOrderId: workOrderId,  不需要
        },
      });
    },

    // 分页切换
    handleCurrentChange(newNum) {
      this.getWorkOrederList(newNum);
    },

    // 获取生产单分页列表
    getWorkOrederList(val) {
      this.pageInfo.page = val;
      this.$requestBase({
        url: "v1/device/list",
        method: "get",
        params: this.pageInfo,
      }).then((res) => {
        console.log(res);
        this.responseData = this.formatResponse(res.data.list);
        this.totalPages = res.data.pages;
      });
    },
    // 格式化生产单列表
    formatResponse(response) {
      response.forEach((item, index) => {
        item.local_id = index + 1;
        item.createTime = this.utils.timestampToTime(item.createTime, 2);
        item.purchaseDate = this.utils.timestampToTime(item.purchaseDate, 2);
      });
      return response;
    },
    // 路由至生产单详情
    // goToWorkOrderDetails(workOrderId) {
    //   this.$router.push(`workOrder/workOrderDetalis/${workOrderId}`);
    // },
    // 在打印当前报表前，拼接title
    initPrint(id) {
      this.utils.printTable(id, `其他设备`);
    },
    handleClick1(workOrderId) {
      this.$router.push({
        path: `otherDeviceAdd`,
        query: {
          type: 1, //0=新建, 1=编辑,
          id: workOrderId,
        },
      });
    },
    handleClick2(id) {
      this.$requestBase({
        url: "v1/device/delete",
        method: "post",
        params: {
          id: id,
        },
      }).then((res) => {
        console.log(res);
        this.$Message.success(res.info);
        this.getWorkOrederList(1);
      });
    },

    // 条件查询
    queryBySelect(pageInfo) {
      this.pageInfo = pageInfo;
      this.getWorkOrederList(1);
    },
    // 清空条件查询
    clearQuery(pageInfo) {
      this.pageInfo = pageInfo;
      this.getWorkOrederList(1);
    },

    // 日期范围选择控件，内容改变事件
    daterangeSelectChange() {
      // console.log('daterangeSelectResult=', this.daterangeSelectResult)
      // console.log('daterangeSelectResult[0]=', this.daterangeSelectResult[0])
      // console.log('daterangeSelectResult[1]=', this.daterangeSelectResult[1])

      //开始时间 转 时间戳
      let m_date = new Date(this.daterangeSelectResult[0]);
      let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
      this.pageInfo.startTime = m_time;
      // console.log('startTime=', this.pageInfo.startTime)

      //结束时间 转 时间戳
      m_date = new Date(this.daterangeSelectResult[1]);
      m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
      this.pageInfo.endTime = m_time;
      // console.log('endTime=', this.pageInfo.endTime)

      this.getWorkOrederList(1);
    },
  },
  mounted() {
    this.getWorkOrederList(1);
  },
  activated() {
    this.getWorkOrederList(1);
  },
};
</script>

<style lang="scss" scoped>
.define-table-container {
  margin-left: -10px !important;
}
// #bianji {
//   cursor: pointer;
//   alt: '编辑';
// }
p {
  // border: 1px solid #EBEEF5;
  // line-height: 0;
  padding: 0;
  margin: 0;
}
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}
.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}
</style>
